<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot=primary>
      <ion-button (click)="modalController.dismiss()"> {{ 'core.done' | translate }} </ion-button>
    </ion-buttons>
    <ion-title>{{ roomData ? roomData.room.roomNo : ('study-areas.studySpaces.selectLocation.occupancySchedule' | translate) }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (roomData?.appointments) {
    <app-timetable class="h-full" [appointments]="roomData.appointments"></app-timetable>
  }
</ion-content>
